import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ValidateCodeComponent } from './validate-code/validate-code.component';
import { VerificationCodeComponent } from './verification-code/verification-code.component';

const routes: Routes = [
  {
    path: "login", component: LoginComponent, data: { animation: 'Login' }
  },
  {
    path: "register", component: RegisterComponent, data: { animation: 'Register' }
  },
  {
    path: "validate-code", component: ValidateCodeComponent, data: { animation: 'CodeValidation' }
  },
  {
    path: "verification-code", component: VerificationCodeComponent, data: { animation: 'CodeValidation' }
  },
  {
    path: "change-password", component: ChangePasswordComponent, data: { animation: 'changePass' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AccountRoutingModule { }
